<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12">
        <div class="login-card">
          <form class="theme-form login-form" @submit.prevent="doLogin">
            <h4 class="mb-3">Login</h4>
            
            <div class="form-group">
              <label>Email Address</label>
              <div class="input-group">
                <span class="input-group-text"><i class="icon-email"></i></span>
                <input v-model="email" class="form-control" type="email" placeholder="Test@gmail.com">
              </div>
            </div>

            <div class="form-group">
              <label>Password</label>
              <div class="input-group">
                <span class="input-group-text"><i class="icon-lock"></i></span>
                <input v-model="password" :type="passwordType" class="form-control" placeholder="*********">
                <div class="show-hide">
                  <span class="show" @click="togglePassword"> </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="checkbox p-0 mb-3 w-100">
                <input id="checkbox1" type="checkbox" />
                <label class="text-muted" for="checkbox1">Remember password</label>
                <router-link class="link" to="/auth/forget-password">Forgot password?</router-link>
              </div>
              <button class="btn btn-primary btn-block" type="submit">
                Login
              </button>
            </div>

            <p class="mt-4 mb-0">
              Don't have account?
              <router-link class="ms-2" to="/auth/register">Create Account</router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from "@/composables/useAuth";
import { useCurrentUser } from "@/composables/useCurrentUser";
import { createToaster } from "@meforma/vue-toaster";
import Cookies from 'js-cookie';

const toaster = createToaster({
  position: "top-right",
  duration: 2000,
});

const router = useRouter();
const { loginApi } = useAuth();
const { reloadCurrentUser } = useCurrentUser();

const email = ref("");
const password = ref("");
const passwordType = ref('password');

const togglePassword = () => {
  passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
};

const doLogin = async () => {
  const params = {
    username: email.value,
    password: password.value,
    client_id: process.env.VUE_APP_PASSWORD_GRANT_CLIENT_ID,
    client_secret: process.env.VUE_APP_PASSWORD_GRANT_CLIENT_SECRET,
    grant_type: "password"
  };

  const result = await loginApi(params);
  
  if (result.success && result.data) {
    const { access_token, refresh_token, expires_in } = result.data;

    const expiryDays = expires_in / 86400; 

    Cookies.set('access_token', access_token, { expires: expiryDays, secure: true, sameSite: 'strict' });
    Cookies.set('refresh_token', refresh_token, { expires: 30, secure: true, sameSite: 'strict' }); 
    localStorage.setItem('user', email.value)
    toaster.success('Thành công!');
    await reloadCurrentUser();
    router.replace('/');
  } else {
    toaster.error("Có lỗi xảy ra: " + (result.error || 'Lỗi hệ thống'));
  }
};
</script>

<style scoped>
.login-form label {
  color: #000 !important;
  font-weight: 600;
}
.login-form .form-control {
  color: #000 !important;
}
.login-form .form-control::placeholder {
  color: #666 !important;
}
.login-form .text-muted {
  color: #000 !important;
}
.login-form h4, .login-form h6 {
  color: #000 !important;
}
.login-form .link {
  color: #000 !important;
  font-weight: 600;
}
</style>